@import "../../../theme/global";
/**
  * @prop --lar-node-cam-modal-text-top: Camera name element top
  * @prop --lar-node-cam-modal-text-right: Camera name element right
  * @prop --lar-node-cam-modal-text-bottom: Camera name element bottom
  * @prop --lar-node-cam-modal-text-left: Camera name element left
  * @prop --lar-node-cam-modal-text-max-width: Camera name element max width
  * @prop --(--lar-modal-info-opacity: Camera info text opacity
  */
  
$node-box-border-radius:      var(--lar-node-box-border-radius, 0.5rem) !default;
$node-node-cam-top:           var(--lar-node-cam-modal-text-top, 0.5rem) !default;
$node-node-cam-right:         var(--lar-node-cam-modal-text-right) !default;
$node-node-cam-bottom:        var(--lar-node-cam-modal-text-bottom) !default;
$node-node-cam-left:          var(--lar-node-cam-modal-text-left, 0.5rem) !default;
$opacity:                     var(--lar-modal-info-opacity, .8) !default;

.lar-video-modal-wrapper, .lar-modal-slot, .lar-video-modal-content {
  position: absolute;
  display: flex;
  flex-direction: column;
  padding-bottom: env(safe-area-inset-bottom);
  @include position(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  z-index: 10;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  justify-content: center;
  @include border-radius($node-box-border-radius);
  overflow: hidden;
}
.lar-video-modal-content::before {
  content: "";
  position: absolute;
  inset: 0;
  @include border-radius($node-box-border-radius);
  pointer-events: none;
  z-index: 100;
}
h3 {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  right: auto;
  bottom: auto;
  margin: 0;
  z-index: 20;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
  font-size: 0.75rem;
  background: lar-color(dark, base);
  color: lar-color(light, base);;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  @include border-radius(0.5rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 1rem);
}
h3:empty {
  display: none !important;
}

div.tapinfo {
  animation: fadeOut 1.5s linear forwards;
  z-index: 20;
  text-align: center;
}
div.tapinfo lar-translate {
  display: inline-block;
  background: lar-color(dark, base);
  color: lar-color(light, base);
  display: inline-block !important;
  padding: 0.5rem;
}

video, canvas {
  object-fit: contain;
}

@mixin generate-node-color($color-name) {
  // Removed aggressive color backgrounds
}

@each $color-name, $value in $colors {
    @include generate-node-color($color-name);
}


@keyframes fadeOut {
  0%   {opacity: $opacity;}
  70%  {opacity: $opacity;}
  90% {opacity: $opacity; transform: translateY(0px);}
  100% {opacity: 0; transform: translateY(-1rem);}
}
